export const LINE_UP_SMALL = '1-5';
export const LINE_UP_MEDIUM = '6-10';
export const LINE_UP_LARGE = '11-';
